import React from 'react';
const TermsOfService = () => {
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1360">
      <div className="max-w-3xl mx-auto" data-id="element-1361">
        <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1362">
          Terms of Service
        </h1>
        <div className="text-sm text-gray-500 mb-8" data-id="element-1363">
          Last updated: June 1, 2023
        </div>
        <div className="prose prose-lg max-w-none" data-id="element-1364">
          <p data-id="element-1365">
            Please read these Terms of Service ("Terms") carefully before using
            the LaraDevs website and services.
          </p>
          <h2 data-id="element-1366">1. Acceptance of Terms</h2>
          <p data-id="element-1367">
            By accessing or using our Services, you agree to be bound by these
            Terms. If you do not agree to these Terms, you may not access or use
            the Services.
          </p>
          <h2 data-id="element-1368">2. Description of Services</h2>
          <p data-id="element-1369">
            LaraDevs provides a platform connecting developers, freelancers, and
            teams with potential employers and clients. Our Services include
            developer profiles, job listings, team pages, blog content, and
            other related features.
          </p>
          <h2 data-id="element-1370">3. User Accounts</h2>
          <p data-id="element-1371">
            To access certain features of our Services, you must register for an
            account. You agree to provide accurate, current, and complete
            information during the registration process and to update such
            information to keep it accurate, current, and complete.
          </p>
          <p data-id="element-1372">
            You are responsible for safeguarding your account and password. You
            agree not to disclose your password to any third party and to take
            sole responsibility for any activities or actions under your
            account, whether or not you have authorized such activities or
            actions.
          </p>
          <h2 data-id="element-1373">4. User Content</h2>
          <p data-id="element-1374">
            Our Services may allow you to post, link, store, share and otherwise
            make available certain information, text, graphics, videos, or other
            material ("Content"). You are responsible for the Content that you
            post on or through the Services, including its legality,
            reliability, and appropriateness.
          </p>
          <p data-id="element-1375">
            By posting Content on or through the Services, you represent and
            warrant that:
          </p>
          <ul data-id="element-1376">
            <li data-id="element-1377">
              The Content is yours (you own it) or you have the right to use it
              and grant us the rights and license as provided in these Terms
            </li>
            <li data-id="element-1378">
              The posting of your Content on or through the Services does not
              violate the privacy rights, publicity rights, copyrights, contract
              rights or any other rights of any person
            </li>
          </ul>
          <h2 data-id="element-1379">5. Fees and Payment</h2>
          <p data-id="element-1380">
            Certain aspects of the Services may be provided for a fee. You agree
            to pay all fees in accordance with the pricing and payment terms
            presented to you for such Services.
          </p>
          <p data-id="element-1381">
            You will provide us with valid, up-to-date, and complete credit card
            or other payment information. You authorize us to charge such
            payment information for all Services listed in an order for the
            initial subscription term and any renewal subscription term.
          </p>
          <h2 data-id="element-1382">6. Termination</h2>
          <p data-id="element-1383">
            We may terminate or suspend your account and bar access to the
            Services immediately, without prior notice or liability, under our
            sole discretion, for any reason whatsoever and without limitation,
            including but not limited to a breach of the Terms.
          </p>
          <p data-id="element-1384">
            If you wish to terminate your account, you may simply discontinue
            using the Services, or notify us that you wish to delete your
            account.
          </p>
          <h2 data-id="element-1385">7. Limitation of Liability</h2>
          <p data-id="element-1386">
            In no event shall LaraDevs, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from:
          </p>
          <ul data-id="element-1387">
            <li data-id="element-1388">
              Your access to or use of or inability to access or use the
              Services
            </li>
            <li data-id="element-1389">Any conduct or content of any third party on the Services</li>
            <li data-id="element-1390">Any content obtained from the Services</li>
            <li data-id="element-1391">
              Unauthorized access, use or alteration of your transmissions or
              content
            </li>
          </ul>
          <h2 data-id="element-1392">8. Governing Law</h2>
          <p data-id="element-1393">
            These Terms shall be governed and construed in accordance with the
            laws of California, United States, without regard to its conflict of
            law provisions.
          </p>
          <h2 data-id="element-1394">9. Changes to Terms</h2>
          <p data-id="element-1395">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will provide
            at least 30 days' notice prior to any new terms taking effect. What
            constitutes a material change will be determined at our sole
            discretion.
          </p>
          <h2 data-id="element-1396">10. Contact Us</h2>
          <p data-id="element-1397">
            If you have any questions about these Terms, please contact us at:
          </p>
          <p data-id="element-1398">
            Email: legal@laradevs.com
            <br data-id="element-1399" />
            Address: 123 Developer Way, Suite 456, San Francisco, CA 94103
          </p>
        </div>
      </div>
    </div>;
};
export default TermsOfService;